export default "__VITE_ASSET__BXYiLVWG__"